module.exports = __webpack_public_path__ + "f0897894a0f984b5faa4558b98194fe6.png";